import axios from 'axios'

import * as types from '../mutation-types'

// state
export const state = {
  loadingEventPusherRequest: true,
  eventPusherRequest: null,
  errorEventPusherRequest: null,
  statusEventPusherRequest: null,
}

// mutations
export const mutations = {
  [types.EVENT_PUSHER_REQUEST_START](state) {
    state.loadingEventPusherRequest = true
    state.eventPusherRequest = null
    state.errorEventPusherRequest = null
    state.statusEventPusherRequest = null
  },

  [types.EVENT_PUSHER_REQUEST_SUCCESS](state, { event }) {
    state.loadingEventPusherRequest = false
    state.eventPusherRequest = event
    state.errorEventPusherRequest = null
  },

  [types.EVENT_PUSHER_REQUEST_ERROR](state, { error }) {
    state.loadingEventPusherRequest = false
    state.eventPusherRequest = null
    state.errorEventPusherRequest = error
  },

  [types.EVENT_PUSHER_REQUEST_SENT](state, status) {
    state.statusEventPusherRequest = status
  },
}

export const actions = {
  async setEventPusherRequest({ commit }, { echo, url, broadcast_as, channel }) {
    try {
      commit(types.EVENT_PUSHER_REQUEST_START)

      axios.get(url)
        .then(response => {
          const { status } = response
          commit(types.EVENT_PUSHER_REQUEST_SENT, status)
        })
        .catch(error => {
          commit(types.EVENT_PUSHER_REQUEST_ERROR, { error })
        })

      echo.channel(channel)
        .listen(
          `.${broadcast_as}`,
          event => {
            commit(types.EVENT_PUSHER_REQUEST_SUCCESS, { event })
          },
        ).error(err => {
          commit(types.EVENT_PUSHER_REQUEST_ERROR, { error: err })
        })
    } catch (error) {
      commit(types.EVENT_PUSHER_REQUEST_ERROR, { error })
    }
  },
}

// getters
export const getters = {
  loadingEventPusherRequest: state => state.loadingEventPusherRequest,
  eventPusherRequest: state => state.eventPusherRequest,
  errorEventPusherRequest: state => state.errorEventPusherRequest,
  statusEventPusherRequest: state => state.statusEventPusherRequest,
}
